/**
 * Copyright (c) 2015 ZenPayroll
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import AlwaysMaskedField from './AlwaysMaskedField';
var MaskedField = function (_a) {
    var mask = _a.mask, props = __rest(_a, ["mask"]);
    if (mask) {
        return React.createElement(AlwaysMaskedField, __assign({ mask: mask }, props));
    }
    var translations = props.translations, onComplete = props.onComplete, valueLink = props.valueLink, inputRef = props.inputRef, inputProps = __rest(props, ["translations", "onComplete", "valueLink", "inputRef"]);
    return React.createElement("input", __assign({}, inputProps, { type: "text" }));
};
MaskedField.propTypes = {
    mask: PropTypes.string
};
MaskedField.defaultProps = {
    mask: undefined
};
export default MaskedField;
//# sourceMappingURL=MaskedField.js.map